import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend
} from 'chart.js';
// import ChartDataLabels from 'chartjs-plugin-datalabels'; // opcional

ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  // ChartDataLabels
);

const GraficaFrecuenciaProductos = ({ data }) => {
  //console.log("📥 Datos recibidos para productos:", data);

  // 🧹 Validación defensiva y limpieza
  const productos = Array.isArray(data)
    ? data.map((item, i) => {
        const nombre = item?.producto?.trim();
        const cantidad = parseInt(item?.cantidad, 10) || 0;
        //console.log("🔎 Primer objeto:", data?.[0]);
        //console.log(`[${i}] producto: ${nombre}, cantidad: ${cantidad}`);
        return { nombre, cantidad };
      }).filter(p => p.nombre && p.cantidad > 0)
    : [];

  if (productos.length === 0) {
    console.warn("⚠️ No se encontraron productos válidos con cantidad.");
  }

  // 📊 Agrupamos sumando cantidades por producto
  const frecuencia = {};
  productos.forEach(({ nombre, cantidad }) => {
    frecuencia[nombre] = (frecuencia[nombre] || 0) + cantidad;
  });

  //console.log("📊 Frecuencia agrupada por producto:", frecuencia);

  const labels = Object.keys(frecuencia).sort(); // orden alfabético
  const valores = labels.map(k => frecuencia[k]);

  // 🎨 Colores institucionales
  const backgroundColor = labels.map(() => '#ffd699');
  const borderColor = labels.map(() => '#ff9900');

  const chartData = {
    labels,
    datasets: [
      {
        label: 'Cantidad reportada por Producto',
        data: valores,
        backgroundColor,
        borderColor,
        borderWidth: 1
      }
    ]
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: context => `Cantidad reportada: ${context.raw}`
        }
      },
      // datalabels: {
      //   anchor: 'end',
      //   align: 'top',
      //   color: '#000',
      //   font: {
      //     weight: 'bold',
      //     size: 12
      //   },
      //   formatter: value => value
      // }
    },
    scales: {
      y: {
        beginAtZero: true,
        title: { display: true, text: 'Cantidad' }
      },
      x: {
        title: { display: true, text: '' },
        ticks: {
          callback: val => labels[val]?.length > 25
            ? labels[val].slice(0, 25) + '…'
            : labels[val]
        }
      }
    }
  };

  return (
    <div style={{ maxWidth: '900px', margin: '2rem auto' }}>
      <h4 style={{ textAlign: 'center', marginBottom: '1rem' }}>
        Cantidad Reportada por Producto
      </h4>
      {labels.length > 0 ? (
        <Bar data={chartData} options={options} />
      ) : (
        <p style={{ textAlign: 'center', color: '#999' }}>
          No hay datos válidos para mostrar.
        </p>
      )}
    </div>
  );
};

export default GraficaFrecuenciaProductos;